const { createImage, duplicateImage } = require('./Image');

const baseInventoryItem = {
  _version: 6,
  uid: '',
  id: '', // Blank
  type: '', // @see InventoryItemTypes
  subType: '', // e.g. 'planet' is a subtype of REAL_ESTATE
  displayName: '',
  description: '',
  data: {}, // Different types use data differently.
  value: 0, // Used by game systems.
  quantity: 1,
  stackSize: 1,
  player: '',
  species: '',
  image: createImage(),
  created: '',
  updated: '',
};

const createInventoryItem = (overrides = {}) => {
  return { ...baseInventoryItem, ...overrides };
};

// Constructor version.
function InventoryItem(overrides = {}) {
  return createInventoryItem(overrides);
}

// TODO When we start using data, we should do a deep copy or we will get bugs.
const duplicateInventoryItem = inventoryItem => ({
  ...inventoryItem,
  date: { ...inventoryItem.data },
  image: duplicateImage(inventoryItem.image)
});

module.exports = {
  createInventoryItem,
  duplicateInventoryItem,
  InventoryItem
};
